import $ from "jquery";
import { dataaccess } from "../dataaccess/dataContext";

let _programs;

function init() {

}

function getPrograms() {
    return $.Deferred(function(def) {
        if (_programs)
            return def.resolve(_programs);
        dataaccess.get({ url: "/Course/program/" }).done(function(result) {
            _programs = result;
            return def.resolve(_programs);
        });
    }).promise();
}

function populateProgramsChecklist(programDiv) {
    return $.Deferred(function(def) {
        getPrograms().done(function(programs) {
            $(programDiv).empty();
            for (let i = 0; i < programs.length; i++) {
                $(programDiv).append("<label class=\"form-check-label\"><input type=\"checkbox\" class=\"form-check-input\" id=\"chkProgramFilter-" + programs[i].id + "\" programId=\"" +
                    programs[i].id +
                    "\" /><span class=\"form-check-sign\"></span>" + "<span for=\"chkProgramFilter-" + programs[i].id + "\">" +
                    programs[i].description +
                    "</span></label> <br>");
            }
            def.resolve();
        });
    });
}
function populateCourseTypesSelect(courseTypeSelectContainerDiv, programValue) {
    $(courseTypeSelectContainerDiv)
        .find("option")
        .not(":first")
        .remove()
        .end()
        .find("select");

    getPrograms().done(function(programs) {
        if (programValue === undefined || programValue.length === 0) {
            for (let a = 0; a < programs.length; a++) {
                for (let b = 0; b < programs[a].programCourseTypes.length; b++) {
                    $(courseTypeSelectContainerDiv).find("select")
                        .append("<option value=\"" +
                            programs[a].programCourseTypes[b].courseType.id +
                            "\">" +
                            programs[a].programCourseTypes[b].courseType.description +
                            "</option>");
                }
            }
        }
        for (let p = 0; p < programValue.length; p++) {
            for (let i = 0; i < programs.length; i++) {
                if (programs[i].id !== parseInt(programValue[p])) continue;

                for (let j = 0; j < programs[i].programCourseTypes.length; j++) {
                    $(courseTypeSelectContainerDiv).find("select")
                        .append("<option value=\"" +
                        programs[i].programCourseTypes[j].courseType.id +
                            "\">" +
                        programs[i].programCourseTypes[j].courseType.description +
                            "</option>");
                }
            }
        }
    });
}

export const programCourseType = {
    init: init,
    getPrograms: getPrograms,
    populateProgramsChecklist: populateProgramsChecklist,
    populateCourseTypesSelect: populateCourseTypesSelect
};